import React from "react";
import {
  IonGrid,
  IonRow,
  IonCol,
  isPlatform,
  IonCard,
  IonCardContent,
  IonCardTitle
} from "@ionic/react";
import "./Services.scss"
import i18n from "../../../../../i18n";
import { NO_SERVICES_TEXT } from "../../../../utils/constants";

export interface ComponentProps {
  services: any[];
  props?: any;
}

export default ({ services }: ComponentProps) => {
  const isMobile = isPlatform("mobile") || isPlatform("mobileweb");
  const paddingClass = isMobile ? "mobile-padding" : "web-padding";

  return (
    <>
      <div className="services-component">
        {!!services.length ? (
          <div className="services">
            <IonCard
              class={`details-services-component ${isMobile ? "" : "webBorder"}`}
            >
              <IonCardTitle
                className="title"
                data-test="title"
                style={{ textAlign: isMobile ? "center" : "left" }}
              >
                <IonCol size="7">{i18n.t("Services Details")}</IonCol>
              </IonCardTitle>
              <IonCardContent>
      
                <div className="services-item-container">
                  {services.map((service: any, index: number) => (
                    <IonGrid
                      className="services-component"
                      key={`${service?.serviceDescription}_${index}`}
                    >
                      <IonRow>
                        <IonCol
                          data-test="description"
                          className={paddingClass}
                        >
                          {service?.serviceDescription}
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                  ))}
                </div>
              </IonCardContent>
            </IonCard>
          </div>
        ) : (
            <>
              <IonCard class="no-services-found">
                <IonCardContent>
                  <div>{i18n.t("noServicesText") || NO_SERVICES_TEXT}</div>
                </IonCardContent>
              </IonCard>
            </>
        )}

      </div>
    </>
  );
};